import {InternalAxiosRequestConfig} from 'axios'
import {HttpInstance} from './createHttpInstance'

interface TransformRequest {
  (
    http: HttpInstance,
    transformFn: (
      request: InternalAxiosRequestConfig,
    ) => InternalAxiosRequestConfig,
  ): void
}

export const transformRequests: TransformRequest = (http, transformFn) => {
  http.interceptors.request.use(transformFn)
}
